import {
  GET_CONSIGNMENT_STATES,
  GET_CONSIGNMENTS,
  GET_SUPPLY_DETAILS,
  GET_BASIC_DETAILS,
  GET_OPERATOR_BY_PHONE,
  GET_THIRD_PARTY_DETAILS,
  GET_ACTIVITY_DETAILS,
  GET_COMMENT_CATEGORIES,
  GET_DEMAND_DETAILS,
  GET_DEMAND_CONFIG,
  CLEAR_RC_NAMES,
  GET_BANK_DETAILS,
  EMPTY_BANK_DETAILS,
  GET_DOCKETS,
  CLEAR_FILES_DOCKET_VIEW,
  GET_RC_URL,
  GET_RELATION_DOC_URL,
  CLEAR_FILES_DOCKET,
  CLEAR_FREIGHT_NAME,
  GET_CURRENT_DOCKET,
  CLEAR_DOCKET,
  CREATE_INVOICE,
  GET_DOCKET_FILE_UPLOAD,
  VIEW_FILES_DOCKET,
  VIEW_INVOICE,
  VIEW_INSURANCE,
  GET_TRIP_DETAILS,
  GET_ADDRESS_DETAILS,
  GET_ADDRESS_DETAILS_OPERATIONV4,
  POST_COMMENT,
  UPDATE_BASIC_DETAIL,
  EDIT_VEHICLE_DETAILS,
  EDIT_DRIVER_DETAILS,
  CREATE_TRANSACTION,
  GET_VIA_POINTS,
  EDIT_TRANSACTION,
  UPDATE_DEMAND_DETAILS,
  UPDATE_FREIGHT_DETAILS,
  GET_EXPENSE_TYPES,
  GET_EXPENSE_TYPES_V3,
  RESET_TABLE,
  ADD_EXPENSE,
  GET_CONSIGNER_CODES,
  UPLOAD_FREIGHT,
  CLEAR_PHONE_OPERATOR,
  CLEAR_FLAGS,
  SAVE_FILTERS,
  UPDATE_VEHICLE_STATE,
  GET_OPERATION_SEARCH,
  UPDATE_LOCATION,
  EDIT_EXPENSE,
  EDIT_START_POINT,
  SAVE_RC_URL,
  EDIT_END_POINT,
  CREATE_VIA_POINT,
  EDIT_VIA_POINT,
  SETTLE_OPERATOR,
  SETTLE_SHIPPER,
  VIEW_FREIGHT,
  CREATE_DOCKET,
  SHARE_PAYMENT_LINK,
  EDIT_DOCKET,
  EDIT_INVOICE,
  EDIT_INSURANCE,
  UPDATE_TIME,
  GET_REMARKS,
  UPDATE_OPERATOR_FREIGHT_DETAILS,
  UPDATE_TAB,
  DELETE_EXPENSE,
  DELETE_DOCKET,
  DELETE_INVOICE,
  GET_RC_CONFIG,
  SAVE_RC_DETAILS,
  CLEAR_RELATION_DOC_NAMES,
  VIEW_RC_RELATION_DOC_URL,
  CLEAR_RC_RELATION_DOC_URL,
  GET_INVOICE_DOC_URL,
  CLEAR_INVOICE_DOC_NAME,
  GET_INSURANCE_DOC_URL,
  CREATE_INSURANCE_DOC_URL,
  GET_INVOICES,
  GET_INSURANCE,
  CLEAR_INVOICE_VIEW,
  SAVE_INVOICE_DETAILS,
  CLEAR_INSURANCE_VIEW,
  SAVE_INSURANCE_DETAILS,
  CLEAR_INSURANCE_DOC_NAME,
  GET_EMAILS_LIST_OP,
  SAVE_POD_STATUS,
  GET_POD_DETAILS,
  GET_POD_HISTORY,
  SUBMIT_POD_DETAILS,
  UPLOAD_POD_DOCUMENTS,
  VIEW_POD_DOCUMENT,
  GET_POD_VALIDITY_REMARK,
  RESET_POD_VALIDITY_REMARK,
  FETCH_CANCEL_UNCANCEL_TRIP_REASONS,
  POST_CANCEL_TRIP,
  // SUBMIT_POD_FILE_DETAILS,
  FETCH_STATES_FOR_DOCKET,
  SAVE_BASIC_DETAILS,
  FETCH_TRIP_MAP_DETAILS,
  GET_TRIP_ITINERARY,
  GET_DELAY_REASONS,
  SAVE_DELAY_REASON,
  GET_CANCEL_REASONS,
  SAVE_CANCEL_REASON,
  GET_EXTRA_EXPENSE_POLICY,
  GET_IMAGE_URL,
  GET_TDS_INFO,
  UPDATE_REFERENCE_ID,
  EDIT_INVOICE_DETAILS,
  UPDATE_STOPPAGE_REASON,
  GET_PHONE_NO,
  RESET_PHONE_NO,
  GET_PAYMENT_BILLING_DATA,
  SUBMIT_PAYMENT_BILLING,
  GET_IMAGE_PROOF_DOCKET_DETAILS,
  SUBMIT_DELAY_MODAL,
  GET_DELAY_MODAL_DATA,
  RESET_GET_DELAY_MODAL_DATA,
  GENERATE_EWAY_BILL_NUMBER,
} from './actions';
import { REQUEST, SUCCESS, FAILURE, RESET } from '../../../utils/actionGenerator';

const defaultState = {
  consignmentStates: [],
  consignments: [],
  createdBy: null,
  supplyDetails: {},
  basicDetails: {},
  cancelConfig: {},
  supplyTransactions: [],
  rowCount: null,
  thirdPartyTransactions: [],
  thirdPartyExpense: {},
  frontRC: '',
  backRC: '',
  demandTransactions: {},
  mgDetails: {},
  selectedTab: 0,
  operatorExpense: {},
  shipperExpense: {},
  phoneOperator: {},
  commentsList: [],
  categories: [],
  operatorSettled: false,
  docketDeleted: false,
  invoiceDeleted: false,
  auditList: [],
  invoiceCreated: false,
  invoiceEdited: false,
  insuranceEdited: false,
  demandDetails: {},
  timeUpdateFailed: false,
  userDetails: {},
  demandConfig: {},
  bankDetails: [],
  remarks: [],
  TdsInfo: {
    maxTdsAmount: null,
    tanNumber: null,
  },
  docketDetails: [],
  docketPodStatus: '',
  biltiWidget: null,
  activeDocket: {},
  frontRcName: '',
  backRcName: '',
  viaPointCreated: false,
  shipperSettled: true,
  docketFileName: '',
  docketFilesView: '',
  invoiceView: '',
  insuranceView: '',
  tripDetails: {},
  currentLocation: {},
  addressDetails: {},
  addressDetailsOperationV4: {},
  commentPosted: false,
  docketCreated: false,
  docketEdited: false,
  updatedBasicDetails: false,
  freightUploaded: false,
  viaPointEdited: false,
  operationSearchResults: [],
  docUploaded: false,
  rcSaved: false,
  updatedVehicleDetails: false,
  updatedDriverDetails: false,
  transactionCreated: false,
  startPointEdited: false,
  endPointEdited: false,
  locationUpdated: false,
  podUploaded: false,
  biltyUploaded: false,
  consignerGoodsInvoiceUploaded: false,
  viaPointsList: [],
  transactionAdded: false,
  vehicleStateFailed: false,
  updateTimeError: '',
  timeUpdated: false,
  updatedDemandBasicDetails: false,
  updatedFreightDetails: false,
  expenseTypes: [],
  expenseTypesV3: {},
  expenseAdded: false,
  expenseEdited: false,
  freightDisplayName: '',
  freightViewLink: '',
  freightFileName: '',
  vehicleStateUpdated: false,
  consignerCodes: [],
  filterObject: {
    indentLoadingTime: [],
    consignerTypes: [],
    toPay: null,
    kycStatus: null,
    podStatus: [],
    consignerCodes: [],
    pocEmail: [],
    createdBy: null,
    podValidity: null,
  },
  updatedOpFreightDetails: false,
  currentStateContext: '',
  expenseDeleted: false,
  errorMessage: '',
  messageType: '',
  expenseDeletedFailed: false,
  expenseEditedFail: false,
  rcConfig: [],
  rcDetailsUpdated: false,
  relationDoc: {},
  rcValidationView: '',
  invoiceDoc: {},
  invoiceList: [],
  invoiceUpdated: false,
  insuranceDoc: {},
  insuranceList: [],
  insuranceUpdated: false,
  assignedToEmailsList: [],
  podStatusUpdated: false,
  podDetails: {},
  podHistory: {},
  podDocDetails: {},
  podDocumentUploaded: false,
  uploadedPodDetails: {},
  podDetailsSaved: false,
  podValidityRemark: null,
  docketStatesOptions: null,
  tripTrackingData: null,
  tripItinerary: {},
  delayReasons: null,
  cancelReasons: null,
  delayReasonPosted: false,
  cancelReasonPosted: false,
  extraExpensePolicyData: [],
  packagingTypeImage: null,
  ShareLinkResponse: false,
  referenceIdUpdated: false,
  invoiceUpdated: false,
  stoppageReasonUpdated: false,
  phoneNo: '',
  billingPaymentData: {},
  nbfcTransactions: {},
  submitBillingData: {},
  imageProofDetails: [],
  delayModalData: {
    delayReason: '',
    materialStatus: '',
    vehicleStatus: '',
    location: '',
    eta: null,
    remarks: '',
    attachments: [],
  },
  generateEwayBillNumber: null,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_CONSIGNMENT_STATES[REQUEST]:
      return { ...state };
    case GET_CONSIGNMENT_STATES[SUCCESS]:
      return { ...state, consignmentStates: action.response };
    case FETCH_CANCEL_UNCANCEL_TRIP_REASONS[REQUEST]:
      return { ...state, cancelConfig: {} };
    case FETCH_CANCEL_UNCANCEL_TRIP_REASONS[SUCCESS]:
      return { ...state, cancelConfig: action.response };
    case FETCH_CANCEL_UNCANCEL_TRIP_REASONS[FAILURE]:
      return { ...state, cancelConfig: {} };
    case GET_CONSIGNER_CODES[REQUEST]:
      return { ...state, consignerCodes: [] };
    case GET_CONSIGNER_CODES[SUCCESS]:
      return { ...state, consignerCodes: action.response };
    case GET_PHONE_NO[REQUEST]:
      return { ...state, phoneNo: '' };
    case GET_PHONE_NO[SUCCESS]:
      return { ...state, phoneNo: action.response };
    case GET_PHONE_NO[FAILURE]:
      return { ...state, phoneNo: '' };
    case RESET_PHONE_NO:
      return { ...state, phoneNo: '' };
    case UPDATE_TAB:
      return { ...state, selectedTab: action.value };
    case UPDATE_VEHICLE_STATE[REQUEST]:
      return { ...state, vehicleStateUpdated: false };
    case UPDATE_VEHICLE_STATE[SUCCESS]:
      return { ...state, vehicleStateUpdated: true };
    case UPDATE_VEHICLE_STATE[FAILURE]:
      return { ...state, vehicleStateFailed: true };
    case GET_OPERATION_SEARCH[REQUEST]:
      return { ...state, operationSearchResults: [] };
    case GET_OPERATION_SEARCH[SUCCESS]:
      return {
        ...state,
        operationSearchResults: action.response.consignmentList,
      };
    case UPDATE_LOCATION[REQUEST]:
      return { ...state, locationUpdated: false };
    case UPDATE_LOCATION[SUCCESS]:
      return { ...state, locationUpdated: true };
    case UPDATE_STOPPAGE_REASON[REQUEST]:
      return { ...state, stoppageReasonUpdated: false };
    case UPDATE_STOPPAGE_REASON[SUCCESS]:
      return { ...state, stoppageReasonUpdated: true };
    case GET_REMARKS[REQUEST]:
      return { ...state, remarks: [] };
    case GET_REMARKS[SUCCESS]:
      return { ...state, remarks: action.response };
    case GET_TDS_INFO[REQUEST]:
      return { ...state, TdsInfo: {} };
    case GET_TDS_INFO[SUCCESS]:
      return { ...state, TdsInfo: action.response };
    case CREATE_DOCKET[REQUEST]:
      return { ...state, docketCreated: false };
    case CREATE_DOCKET[SUCCESS]:
      return { ...state, docketCreated: true };
    case SHARE_PAYMENT_LINK[REQUEST]:
      return { ...state, ShareLinkResponse: false };
    case SHARE_PAYMENT_LINK[SUCCESS]:
      return { ...state, ShareLinkResponse: true };
    case EDIT_INVOICE[REQUEST]:
      return { ...state, invoiceEdited: false };
    case EDIT_INVOICE[SUCCESS]:
      return { ...state, invoiceEdited: true };
    case EDIT_INSURANCE[REQUEST]:
      return { ...state, insuranceEdited: false };
    case EDIT_INSURANCE[SUCCESS]:
      return { ...state, insuranceEdited: true };
    case VIEW_FREIGHT[REQUEST]:
      return { ...state, freightViewLink: '' };
    case VIEW_FREIGHT[SUCCESS]:
      return { ...state, freightViewLink: action.response.viewUrl };
    case CLEAR_RC_NAMES:
      return { ...state, frontRcName: '', backRcName: '' };
    case CLEAR_RELATION_DOC_NAMES:
      return { ...state, relationDoc: {} };
    case CLEAR_INVOICE_DOC_NAME:
      return { ...state, invoiceDoc: {} };
    case CLEAR_INSURANCE_DOC_NAME:
      return { ...state, insuranceDoc: {} };
    case EDIT_DOCKET[REQUEST]:
      return { ...state, docketEdited: false };
    case EDIT_DOCKET[SUCCESS]:
      return { ...state, docketEdited: true };
    case CLEAR_FREIGHT_NAME:
      return { ...state, freightDisplayName: '' };
    case UPDATE_TIME[REQUEST]:
      return { ...state, timeUpdated: false, updateTimeError: '' };
    case UPDATE_TIME[SUCCESS]:
      return { ...state, timeUpdated: true, updateTimeError: '' };
    case UPDATE_TIME[FAILURE]:
      return { ...state, timeUpdateFailed: true, updateTimeError: action.response.message };
    case CREATE_VIA_POINT[REQUEST]:
      return { ...state, viaPointCreated: false };
    case CREATE_VIA_POINT[SUCCESS]:
      return { ...state, viaPointCreated: true };
    case CREATE_INVOICE[REQUEST]:
      return { ...state, invoiceCreated: false };
    case CREATE_INVOICE[SUCCESS]:
      return { ...state, invoiceCreated: true };
    case EDIT_START_POINT[REQUEST]:
      return { ...state, startPointEdited: false };
    case EDIT_START_POINT[SUCCESS]:
      return { ...state, startPointEdited: true };
    case SETTLE_OPERATOR[REQUEST]:
      return { ...state, operatorSettled: false };
    case SETTLE_OPERATOR[SUCCESS]:
      return { ...state, operatorSettled: true };
    case SAVE_BASIC_DETAILS[REQUEST]:
      return { ...state, updatedBasicDetails: false };
    case SAVE_BASIC_DETAILS[SUCCESS]:
      return { ...state, updatedBasicDetails: true };
    case SETTLE_SHIPPER[REQUEST]:
      return { ...state, shipperSettled: false };
    case SETTLE_SHIPPER[SUCCESS]:
      return { ...state, shipperSettled: true };
    case EDIT_VIA_POINT[REQUEST]:
      return { ...state, viaPointEdited: false };
    case EDIT_VIA_POINT[SUCCESS]:
      return { ...state, viaPointEdited: true };
    case EDIT_END_POINT[REQUEST]:
      return { ...state, endPointEdited: false };
    case EDIT_END_POINT[SUCCESS]:
      return { ...state, endPointEdited: true };
    case DELETE_DOCKET[REQUEST]:
      return { ...state, docketDeleted: false };
    case DELETE_DOCKET[SUCCESS]:
      return { ...state, docketDeleted: true };
    case DELETE_INVOICE[REQUEST]:
      return { ...state, invoiceDeleted: false };
    case DELETE_INVOICE[SUCCESS]:
      return { ...state, invoiceDeleted: true };
    case SAVE_RC_URL[REQUEST]:
      return { ...state, rcSaved: false };
    case SAVE_RC_URL[SUCCESS]:
      return { ...state, rcSaved: true };
    case CLEAR_FILES_DOCKET:
      return { ...state, fileNameDocket: '' };
    case SAVE_FILTERS:
      return { ...state, filterObject: action.filter };
    case GET_CONSIGNMENTS[REQUEST]:
      return action.str ? { ...state, consignments: [], rowCount: null } : { ...state };
    case GET_CONSIGNMENTS[SUCCESS]:
      const { page } = action.params;
      if (page > 0) {
        return {
          ...state,
          consignments: state.consignments.concat(action.response.consignmentList),
          rowCount: action.response.count ? action.response.count : state.rowCount,
          createdBy: action.response.defaultFilter ? action.response.defaultFilter : null,
        };
      } else {
        return {
          ...state,
          consignments: state.consignments.concat(action.response.consignmentList),
          rowCount: action.response.count,
          createdBy: action.response.defaultFilter ? action.response.defaultFilter : null,
        };
      }
    case GET_EXPENSE_TYPES[REQUEST]:
      return { ...state, expenseTypes: [], rowCount: null };
    case GET_EXPENSE_TYPES[SUCCESS]:
      return { ...state, expenseTypes: action.response };
    case GET_EXPENSE_TYPES_V3[REQUEST]:
      return { ...state, expenseTypesV3: [], rowCount: null };
    case GET_EXPENSE_TYPES_V3[SUCCESS]:
      return { ...state, expenseTypesV3: action.response };
    case CLEAR_FLAGS:
      return {
        ...state,
        expenseAdded: false,
        expenseEdited: false,
        transactionCreated: false,
        transactionAdded: false,
        docketDeleted: false,
        invoiceDeleted: false,
        docUploaded: false,
        rcSaved: false,
        freightUploaded: false,
        timeUpdateFailed: false,
        docketfilesUploaded: false,
        updatedVehicleDetails: false,
        updateTimeError: '',
        updatedDriverDetails: false,
        updatedFreightDetails: false,
        updatedBasicDetails: false,
        updatedDemandBasicDetails: false,
        errorMessage: '',
        messageType: '',
        expenseDeletedFailed: false,
        expenseEditedFail: false,
        updatedOpFreightDetails: false,
        rcDetailsUpdated: false,
        rcValidationView: '',
        invoiceUpdated: false,
        insuranceUpdated: false,
        podUploaded: false,
        biltyUploaded: false,
        consignerGoodsInvoiceUploaded: false,
      };
    case RESET_TABLE:
      return { ...state, consignments: [] };
    case GET_VIA_POINTS[REQUEST]:
      return { ...state, viaPointsList: [] };
    case GET_VIA_POINTS[SUCCESS]:
      return { ...state, viaPointsList: action.response };
    case CLEAR_PHONE_OPERATOR:
      return { ...state, phoneOperator: {} };
    case GET_ADDRESS_DETAILS[REQUEST]:
      return { ...state, addressDetails: {} };
    case GET_ADDRESS_DETAILS[SUCCESS]:
      return { ...state, addressDetails: action.response };
    case GET_ADDRESS_DETAILS_OPERATIONV4[REQUEST]:
      return { ...state, addressDetailsV4: {} };
    case GET_ADDRESS_DETAILS_OPERATIONV4[SUCCESS]:
      return { ...state, addressDetailsV4: action.response };
    case GET_TRIP_DETAILS[REQUEST]:
      return { ...state, tripDetails: {}, currentLocation: {} };
    case GET_TRIP_DETAILS[SUCCESS]:
      return {
        ...state,
        tripDetails: action.response[0].data.data,
        currentLocation: action.response[1].data.data,
        currentStateContext: action.response[0].data.data.vehicleState,
      };
    case VIEW_FILES_DOCKET[REQUEST]:
      return { ...state, docketFilesView: '' };
    case VIEW_FILES_DOCKET[SUCCESS]:
      return { ...state, docketFilesView: action.response.viewUrl };
    case CLEAR_FILES_DOCKET_VIEW:
      return { ...state, docketFilesView: '', freightViewLink: '' };
    case VIEW_INVOICE[REQUEST]:
      return { ...state, invoiceView: '' };
    case VIEW_INVOICE[SUCCESS]:
      return { ...state, invoiceView: action.response.viewUrl };
    case CLEAR_INVOICE_VIEW:
      return { ...state, invoiceView: '' };
    case VIEW_INSURANCE[REQUEST]:
      return { ...state, insuranceView: '' };
    case VIEW_INSURANCE[SUCCESS]:
      return { ...state, insuranceView: action.response.viewUrl };
    case CLEAR_INSURANCE_VIEW:
      return { ...state, insuranceView: '' };
    case GET_DOCKET_FILE_UPLOAD[REQUEST]:
      return {
        ...state,
        docketFileName: '',
        biltyUploaded: false,
        podUploaded: false,
        consignerGoodsInvoiceUploaded: false,
      };
    case GET_DOCKET_FILE_UPLOAD[SUCCESS]:
      if (action.payload === 'BILTY')
        return {
          ...state,
          podUploaded: false,
          biltyUploaded: true,
          consignerGoodsInvoiceUploaded: false,
          docketFileName: action.response,
        };
      else if (action.payload === 'CONSIGNERGOODSINVOICE')
        return {
          ...state,
          podUploaded: false,
          biltyUploaded: false,
          consignerGoodsInvoiceUploaded: true,
          docketFileName: action.response,
        };
      else if (action.payload === 'POD')
        return {
          ...state,
          podUploaded: true,
          biltyUploaded: false,
          consignerGoodsInvoiceUploaded: false,
          docketFileName: action.response,
        };
      else {
        return {
          ...state,
        };
      }
    case UPLOAD_FREIGHT[REQUEST]:
      return { ...state, freightFileName: '', freightUploaded: false, freightDisplayName: '' };
    case UPLOAD_FREIGHT[SUCCESS]:
      return {
        ...state,
        freightFileName: action.response,
        freightUploaded: true,
        freightDisplayName: 'Freight_approval.img',
      };
    case CLEAR_DOCKET:
      return { ...state, activeDocket: {} };
    case GET_CURRENT_DOCKET[REQUEST]:
      return { ...state, activeDocket: {} };
    case GET_CURRENT_DOCKET[SUCCESS]:
      return { ...state, activeDocket: action.response };
    case GET_RC_URL[REQUEST]:
      return { ...state, docUploaded: false };
    case GET_RC_URL[SUCCESS]: {
      if (action.payload.type === 'front') {
        return { ...state, frontRC: action.response.viewUrl, docUploaded: true, frontRcName: 'Front_RC.img' };
      } else if (action.payload.type === 'back') {
        return { ...state, backRC: action.response.viewUrl, docUploaded: true, backRcName: 'Back_RC.img' };
      } else {
        return { ...state };
      }
    }
    case GET_RELATION_DOC_URL[REQUEST]:
      return { ...state, docUploaded: false };
    case GET_RELATION_DOC_URL[SUCCESS]: {
      return { ...state, docUploaded: true, relationDoc: action.response };
    }
    case GET_INVOICE_DOC_URL[REQUEST]:
      return { ...state, docUploaded: false };
    case GET_INVOICE_DOC_URL[SUCCESS]: {
      return { ...state, docUploaded: true, invoiceDoc: action.response };
    }
    case GET_INSURANCE_DOC_URL[REQUEST]:
      return { ...state, docUploaded: false };

    case GET_INSURANCE_DOC_URL[SUCCESS]: {
      return { ...state, docUploaded: true, insuranceDoc: action.response };
    }
    case GET_DEMAND_CONFIG[REQUEST]:
      return { ...state, demandConfig: {} };
    case GET_DEMAND_CONFIG[SUCCESS]:
      return { ...state, demandConfig: action.response };
    case GET_DOCKETS[REQUEST]:
      return { ...state, docketDetails: [], docketPodStatus: '', biltiWidget: null };
    case GET_DOCKETS[SUCCESS]:
      return {
        ...state,
        docketDetails: action.response.dockets,
        docketPodStatus: action.response.podStatus,
        biltiWidget: action.response.biltiWidget,
      };
    case GET_INVOICES[REQUEST]:
      return { ...state, invoiceList: [] };
    case GET_INVOICES[SUCCESS]: {
      return { ...state, invoiceList: action.response };
    }
    case GET_INSURANCE[REQUEST]:
      return { ...state, insuranceList: [] };
    case GET_INSURANCE[SUCCESS]: {
      return { ...state, insuranceList: action.response };
    }
    case EMPTY_BANK_DETAILS:
      return { ...state, bankDetails: [] };
    case GET_BANK_DETAILS[REQUEST]:
      return { ...state, bankDetails: [] };
    case GET_BANK_DETAILS[SUCCESS]:
      return { ...state, bankDetails: action.response.accounts };
    case GET_DEMAND_DETAILS[REQUEST]:
      return {
        ...state,
        demandDetails: {},
        demandTransactions: {},
        userDetails: {},
        shipperExpense: {},
        expenseEditedErrorMsg: '',
      };
    // case GET_DEMAND_DETAILS[SUCCESS]:
    //   return {
    //     ...state,
    //     demandDetails: action.response[0].data.data,
    //     demandTransactions: action.response[1].data.data.transactions,
    //     userDetails: action.response[2].data.data,
    //     shipperExpense: action.response[3].data.data,
    //     nbfcTransactions: action.response[4].data.data.transactions,
    //   };
    case GET_DEMAND_DETAILS[FAILURE]:
      return { ...state };

    case GET_DEMAND_DETAILS[SUCCESS]:
      return {
        ...state,
        demandDetails: action.response.demandDetails.data.data,
        demandTransactions: action.response?.transactions.data.data,
        userDetails: action.response.userDetails.data.data,
        shipperExpense: action.response.expenses.data.data,
        nbfcTransactions: action.response?.nbfcTransactions.data.data,
      };

    case GET_OPERATOR_BY_PHONE[REQUEST]:
      return { ...state, phoneOperator: {} };
    case GET_OPERATOR_BY_PHONE[SUCCESS]:
      return { ...state, phoneOperator: action.response };
    case GET_SUPPLY_DETAILS[REQUEST]:
      return {
        ...state,
        supplyDetails: {},
        supplyTransactions: [],
        mgDetails: {},
        operatorExpense: {},
        expenseEditedErrorMsg: '',
      };
    case GET_SUPPLY_DETAILS[SUCCESS]:
      return {
        ...state,
        supplyDetails: action.response[0].data.data,
        supplyTransactions: action.response[1].data.data.transactions,
        mgDetails: action.response[2].data.data,
        operatorExpense: action.response[3].data.data,
      };
    case GET_THIRD_PARTY_DETAILS[REQUEST]:
      return { ...state, thirdPartyTransactions: [], thirdPartyExpense: {}, expenseEditedErrorMsg: '' };
    case GET_THIRD_PARTY_DETAILS[SUCCESS]:
      return {
        ...state,
        thirdPartyTransactions: action.response[0].data.data.transactions,
        thirdPartyExpense: action.response[1].data.data,
      };
    case POST_CANCEL_TRIP[SUCCESS]:
      return {
        ...state,
        reload: true,
      };
    case GET_BASIC_DETAILS[REQUEST]:
      return { ...state, basicDetails: {} };
    case GET_BASIC_DETAILS[SUCCESS]:
      return { ...state, basicDetails: action.response };
    case GET_COMMENT_CATEGORIES[REQUEST]:
      return { ...state, categories: [] };
    case GET_COMMENT_CATEGORIES[SUCCESS]:
      return { ...state, categories: action.response[0].data.data };
    case GET_ACTIVITY_DETAILS[REQUEST]:
      return { ...state, commentsList: [], auditList: [] };
    case GET_ACTIVITY_DETAILS[SUCCESS]:
      return {
        ...state,
        commentsList: action.response[0].data.data,
        auditList: action.response[1].data.data.stateDetails,
      };
    case POST_COMMENT[REQUEST]:
      return { ...state, commentPosted: false };
    case POST_COMMENT[SUCCESS]:
      return {
        ...state,
        commentPosted: true,
      };
    case UPDATE_BASIC_DETAIL[REQUEST]:
      return { ...state, updatedBasicDetails: false };
    case UPDATE_BASIC_DETAIL[SUCCESS]:
      return {
        ...state,
        updatedBasicDetails: true,
      };
    case EDIT_VEHICLE_DETAILS[REQUEST]:
      return { ...state, updatedVehicleDetails: false };
    case EDIT_VEHICLE_DETAILS[SUCCESS]:
      return {
        ...state,
        updatedVehicleDetails: true,
      };
    case EDIT_DRIVER_DETAILS[REQUEST]:
      return { ...state, updatedDriverDetails: false };
    case EDIT_DRIVER_DETAILS[SUCCESS]:
      return {
        ...state,
        updatedDriverDetails: true,
      };

    case CREATE_TRANSACTION[REQUEST]:
      return { ...state, transactionCreated: false };
    case CREATE_TRANSACTION[SUCCESS]:
      return {
        ...state,
        transactionCreated: true,
      };
    case EDIT_TRANSACTION[REQUEST]:
      return { ...state, transactionAdded: false };
    case EDIT_TRANSACTION[SUCCESS]:
      return {
        ...state,
        transactionAdded: true,
      };
    case UPDATE_DEMAND_DETAILS[REQUEST]:
      return { ...state, updatedDemandBasicDetails: false };
    case UPDATE_DEMAND_DETAILS[SUCCESS]:
      return {
        ...state,
        updatedDemandBasicDetails: true,
      };
    case UPDATE_FREIGHT_DETAILS[REQUEST]:
      return { ...state, updatedFreightDetails: false };
    case UPDATE_FREIGHT_DETAILS[SUCCESS]:
      return {
        ...state,
        updatedFreightDetails: true,
      };
    case UPDATE_OPERATOR_FREIGHT_DETAILS[REQUEST]:
      return { ...state, updatedOpFreightDetails: false };
    case UPDATE_OPERATOR_FREIGHT_DETAILS[SUCCESS]:
      return {
        ...state,
        updatedOpFreightDetails: true,
      };
    case ADD_EXPENSE[REQUEST]:
      return { ...state, expenseAdded: false, expenseEditedFail: false, errorMessage: '', messageType: '' };
    case ADD_EXPENSE[SUCCESS]:
      return {
        ...state,
        expenseAdded: true,
        errorMessage: 'Expense added succesfully',
        messageType: 'success',
        expenseEditedFail: false,
      };
    case ADD_EXPENSE[FAILURE]:
      return {
        ...state,
        expenseAdded: false,
        errorMessage: action.response.message,
        messageType: 'error',
        expenseEditedFail: true,
      };
    case EDIT_EXPENSE[REQUEST]:
      return { ...state, expenseEdited: false, expenseEditedFail: false, errorMessage: '', messageType: '' };
    case EDIT_EXPENSE[SUCCESS]:
      return {
        ...state,
        expenseEdited: true,
        errorMessage: 'Expense edited successfully',
        messageType: 'success',
        expenseEditedFail: false,
      };
    case EDIT_EXPENSE[FAILURE]:
      return {
        ...state,
        expenseEdited: false,
        errorMessage: action.response.message,
        messageType: 'error',
        expenseEditedFail: true,
      };
    case DELETE_EXPENSE[REQUEST]:
      return { ...state, expenseDeleted: false, errorMessage: '', messageType: '', expenseDeletedFailed: false };
    case DELETE_EXPENSE[SUCCESS]:
      return {
        ...state,
        expenseDeleted: true,
        errorMessage: 'Expense deleted successfully',
        messageType: 'success',
      };
    case DELETE_EXPENSE[FAILURE]:
      return {
        ...state,
        expenseDeleted: false,
        errorMessage: action.response.message,
        messageType: 'error',
        expenseDeletedFailed: true,
      };
    case GET_RC_CONFIG[REQUEST]:
      return {
        ...state,
        rcConfig: {},
        errorMessage: '',
        messageType: '',
      };
    case GET_RC_CONFIG[SUCCESS]:
      return {
        ...state,
        rcConfig: action.response,
        errorMessage: '',
        messageType: '',
      };
    case GET_RC_CONFIG[FAILURE]:
      return {
        ...state,

        errorMessage: action.response.message,
        messageType: 'error',
      };
    case SAVE_RC_DETAILS[REQUEST]:
      return {
        ...state,
        rcDetailsUpdated: false,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_RC_DETAILS[SUCCESS]:
      return {
        ...state,
        rcDetailsUpdated: true,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_RC_DETAILS[FAILURE]:
      return {
        ...state,
        rcDetailsUpdated: false,
        errorMessage: action.response.message,
        messageType: 'error',
      };
    case VIEW_RC_RELATION_DOC_URL[REQUEST]:
      return { ...state, rcValidationView: '' };
    case VIEW_RC_RELATION_DOC_URL[SUCCESS]:
      return { ...state, rcValidationView: action.response.viewUrl };
    case CLEAR_RC_RELATION_DOC_URL:
      return { ...state, rcValidationView: '' };
    case SAVE_INVOICE_DETAILS[REQUEST]:
      return {
        ...state,
        invoiceUpdated: false,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_INVOICE_DETAILS[SUCCESS]:
      return {
        ...state,
        invoiceUpdated: true,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_INVOICE_DETAILS[FAILURE]:
      return {
        ...state,
        invoiceUpdated: false,
        errorMessage: action.response.message,
        messageType: 'error',
      };
    case SAVE_INSURANCE_DETAILS[REQUEST]:
      return {
        ...state,
        insuranceUpdated: false,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_INSURANCE_DETAILS[SUCCESS]:
      return {
        ...state,
        insuranceUpdated: true,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_INSURANCE_DETAILS[FAILURE]:
      return {
        ...state,
        insuranceUpdated: false,
        errorMessage: action.response.message,
        messageType: 'error',
      };

    case GET_EMAILS_LIST_OP[REQUEST]:
      return { ...state };
    case GET_EMAILS_LIST_OP[SUCCESS]: {
      return { ...state, assignedToEmailsList: action.response.users };
    }

    case SAVE_POD_STATUS[REQUEST]:
      return {
        ...state,
        podStatusUpdated: false,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_POD_STATUS[SUCCESS]:
      return {
        ...state,
        podStatusUpdated: true,
        errorMessage: '',
        messageType: '',
      };
    case SAVE_POD_STATUS[FAILURE]:
      return {
        ...state,
        podStatusUpdated: false,
        errorMessage: action.response.message,
        messageType: 'error',
      };

    case GET_POD_DETAILS[REQUEST]:
      return {
        ...state,
        podDetails: {},
      };
    case GET_POD_DETAILS[SUCCESS]:
      return {
        ...state,
        podDetails: action.response[0].data.data,
        // podStatusUpdated: true,
        // errorMessage: '',
        // messageType: '',
      };
    case GET_POD_DETAILS[FAILURE]:
      return {
        ...state,
        // podStatusUpdated: false,
        // errorMessage: action.response.message,
        // messageType: 'error',
      };

    case GET_POD_HISTORY[REQUEST]:
      return {
        ...state,
        podHistory: {},
      };
    case GET_POD_HISTORY[SUCCESS]:
      return {
        ...state,
        podHistory: action.response[0].data.data.podHistory,
      };
    case GET_POD_HISTORY[FAILURE]:
      return {
        ...state,
      };

    case SUBMIT_POD_DETAILS[REQUEST]:
      return {
        ...state,
        podDetailsSaved: false,
      };
    case SUBMIT_POD_DETAILS[SUCCESS]:
      return {
        ...state,
        podDetailsSaved: true,
      };
    case SUBMIT_POD_DETAILS[FAILURE]:
      return {
        ...state,
        podDetailsSaved: false,
      };
    case UPLOAD_POD_DOCUMENTS[REQUEST]:
      return {
        ...state,

        podDocumentUploaded: false,
        uploadedPodDetails: {},
      };
    case UPLOAD_POD_DOCUMENTS[SUCCESS]:
      return {
        ...state,
        podDocumentUploaded: true,
        uploadedPodDetails: action.response[0].data.data,
      };
    case UPLOAD_POD_DOCUMENTS[FAILURE]:
      return {
        ...state,
        podDocumentUploaded: false,
        uploadedPodDetails: {},
      };

    case VIEW_POD_DOCUMENT[REQUEST]:
      return {
        ...state,
        podDocDetails: {},
      };
    case VIEW_POD_DOCUMENT[SUCCESS]:
      // console.log('action.response', action.response[0].data.data);
      return {
        ...state,
        podDocDetails: action.response[0].data.data,
      };
    case VIEW_POD_DOCUMENT[FAILURE]:
      return {
        ...state,
      };

    case GET_POD_VALIDITY_REMARK[REQUEST]:
      return {
        ...state,
        podValidityRemark: null,
      };
    case GET_POD_VALIDITY_REMARK[SUCCESS]:
      return {
        ...state,
        podValidityRemark: action.response[0].data.data,
      };
    case GET_POD_VALIDITY_REMARK[FAILURE]:
      return {
        ...state,
        podValidityRemark: null,
      };
    case RESET_POD_VALIDITY_REMARK:
      return {
        ...state,
        podValidityRemark: null,
      };
    case FETCH_STATES_FOR_DOCKET[REQUEST]:
      return {
        ...state,
        docketStatesOptions: null,
      };
    case FETCH_STATES_FOR_DOCKET[SUCCESS]:
      return {
        ...state,
        docketStatesOptions: action.response[0].data.data.stateCodesConfig,
      };
    case FETCH_STATES_FOR_DOCKET[FAILURE]:
      return {
        ...state,
        docketStatesOptions: null,
      };
    case FETCH_TRIP_MAP_DETAILS[REQUEST]:
      return {
        ...state,
        tripTrackingData: null,
      };
    case FETCH_TRIP_MAP_DETAILS[SUCCESS]:
      return {
        ...state,
        tripTrackingData: action.response[0].data.data,
      };
    case FETCH_TRIP_MAP_DETAILS[FAILURE]:
      return {
        ...state,
        tripTrackingData: null,
      };
    case GET_TRIP_ITINERARY[REQUEST]:
      return {
        ...state,
        tripItinerary: {},
      };
    case GET_TRIP_ITINERARY[SUCCESS]:
      return {
        ...state,
        tripItinerary: action.response[0].data.data,
        currentStateContext: action.response[0].data.data.currentState.state,
      };
    case GET_TRIP_ITINERARY[FAILURE]:
      return {
        ...state,
        tripItinerary: {},
      };
    case GET_DELAY_REASONS[REQUEST]:
      return {
        ...state,
        delayReasons: null,
      };
    case GET_DELAY_REASONS[SUCCESS]:
      return {
        ...state,
        delayReasons: action.response[0].data.data,
      };
    case GET_DELAY_REASONS[FAILURE]:
      return {
        ...state,
        delayReasons: null,
      };
    case GET_CANCEL_REASONS[REQUEST]:
      return {
        ...state,
        cancelReasons: null,
      };
    case GET_CANCEL_REASONS[SUCCESS]:
      return {
        ...state,
        cancelReasons: action.response[0].data.data,
      };
    case GET_CANCEL_REASONS[FAILURE]:
      return {
        ...state,
        cancelReasons: null,
      };
    case SAVE_DELAY_REASON[REQUEST]:
      return {
        ...state,
        delayReasonPosted: false,
      };
    case SAVE_DELAY_REASON[SUCCESS]:
      return {
        ...state,
        delayReasonPosted: true,
      };
    case SAVE_DELAY_REASON[FAILURE]:
      return {
        ...state,
        delayReasonPosted: false,
      };
    case SAVE_CANCEL_REASON[REQUEST]:
      return {
        ...state,
        cancelReasonPosted: false,
      };
    case SAVE_CANCEL_REASON[SUCCESS]:
      return {
        ...state,
        cancelReasonPosted: true,
      };
    case SAVE_CANCEL_REASON[FAILURE]:
      return {
        ...state,
        cancelReasonPosted: false,
      };
    case GET_EXTRA_EXPENSE_POLICY[REQUEST]:
      return {
        ...state,
        extraExpensePolicyData: [],
      };
    case GET_EXTRA_EXPENSE_POLICY[SUCCESS]:
      return {
        ...state,
        extraExpensePolicyData: action.response.data.extraCharges,
      };
    case GET_EXTRA_EXPENSE_POLICY[FAILURE]:
      return {
        ...state,
        extraExpensePolicyData: [],
      };
    case GET_IMAGE_URL[REQUEST]:
      return {
        ...state,
        packagingTypeImage: null,
      };
    case GET_IMAGE_URL[SUCCESS]:
      return {
        ...state,
        packagingTypeImage: action?.response[0]?.data?.data?.url,
      };
    case GET_IMAGE_URL[FAILURE]:
      return {
        ...state,
        packagingTypeImage: null,
      };
    case UPDATE_REFERENCE_ID[REQUEST]:
      return { ...state, referenceIdUpdated: false };
    case UPDATE_REFERENCE_ID[SUCCESS]:
      return { ...state, referenceIdUpdated: true };
    case UPDATE_REFERENCE_ID[FAILURE]:
      return { ...state, referenceIdUpdated: false };
    case EDIT_INVOICE_DETAILS[REQUEST]:
      return { ...state, invoiceUpdated: false };
    case EDIT_INVOICE_DETAILS[SUCCESS]:
      return { ...state, invoiceUpdated: true };
    case EDIT_INVOICE_DETAILS[FAILURE]:
      return { ...state, invoiceUpdated: false };

    case GET_PAYMENT_BILLING_DATA[REQUEST]:
      return { ...state, billingPaymentData: {} };
    case GET_PAYMENT_BILLING_DATA[SUCCESS]:
      return { ...state, billingPaymentData: action.response };
    case GET_PAYMENT_BILLING_DATA[FAILURE]:
      return { ...state, billingPaymentData: action.response };

    case SUBMIT_PAYMENT_BILLING[REQUEST]:
      return { ...state, submitBillingData: {} };
    case SUBMIT_PAYMENT_BILLING[SUCCESS]:
      return { ...state, submitBillingData: action.response };
    case SUBMIT_PAYMENT_BILLING[FAILURE]:
      return { ...state, submitBillingData: action.response };
    case GET_IMAGE_PROOF_DOCKET_DETAILS[REQUEST]:
      return { ...state, imageProofDetails: [] };
    case GET_IMAGE_PROOF_DOCKET_DETAILS[SUCCESS]:
      return {
        ...state,
        imageProofDetails: action.response,
      };
    case GET_IMAGE_PROOF_DOCKET_DETAILS[FAILURE]:
      return {
        ...state,
        imageProofDetails: action.response,
      };

    case SUBMIT_DELAY_MODAL[REQUEST]:
      return { ...state, submitDelayData: {} };
    case SUBMIT_DELAY_MODAL[SUCCESS]:
      return { ...state, submitDelayData: action.response };
    case SUBMIT_DELAY_MODAL[FAILURE]:
      return { ...state, submitDelayData: {} };

    case GET_DELAY_MODAL_DATA[REQUEST]:
      return { ...state, delayModalData: {} };
    case GET_DELAY_MODAL_DATA[SUCCESS]:
      return { ...state, delayModalData: action.response };
    case GET_DELAY_MODAL_DATA[FAILURE]:
      return { ...state, delayModalData: {} };
    case RESET_GET_DELAY_MODAL_DATA[RESET]:
      return {
        ...state,
        delayModalData: {},
      };
    case GENERATE_EWAY_BILL_NUMBER[REQUEST]:
      return { ...state, generateEwayBillNumber: {} };
    case GENERATE_EWAY_BILL_NUMBER[SUCCESS]:
      return { ...state, generateEwayBillNumber: action.response };
    case GENERATE_EWAY_BILL_NUMBER[FAILURE]:
      return { ...state, generateEwayBillNumber: {} };
    default:
      return state;
  }
}

export const getOperationsReducer = (state) => state.operations;
